import { Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { InboxEmailStatus, InboxRunStatus } from '@hub/contracts'
import { cn } from '@/lib/utils'

const EMAIL_STATUS_CLASS: Record<InboxEmailStatus, string> = {
  new: 'bg-blue-500/10 text-blue-700 dark:text-blue-300',
  no_match: 'bg-muted text-muted-foreground',
  matched: 'bg-indigo-500/10 text-indigo-700 dark:text-indigo-300',
  processing: 'bg-amber-500/10 text-amber-700 dark:text-amber-300',
  done: 'bg-emerald-500/10 text-emerald-700 dark:text-emerald-300',
  failed: 'bg-destructive/10 text-destructive',
}

export function EmailStatusPill({
  status,
  className,
}: {
  status: InboxEmailStatus
  className?: string
}) {
  const { t } = useTranslation('inbox')
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium whitespace-nowrap',
        EMAIL_STATUS_CLASS[status],
        className
      )}
    >
      {status === 'processing' && <Loader2 className="h-3 w-3 animate-spin" />}
      {t(`status.${status}`)}
    </span>
  )
}

const RUN_STATUS_CLASS: Record<InboxRunStatus, string> = {
  queued: 'bg-muted text-muted-foreground',
  running: 'bg-amber-500/10 text-amber-700 dark:text-amber-300',
  done: 'bg-emerald-500/10 text-emerald-700 dark:text-emerald-300',
  failed: 'bg-destructive/10 text-destructive',
}

export function RunStatusPill({ status }: { status: InboxRunStatus }) {
  const { t } = useTranslation('inbox')
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium whitespace-nowrap',
        RUN_STATUS_CLASS[status]
      )}
    >
      {status === 'running' && <Loader2 className="h-3 w-3 animate-spin" />}
      {t(`runs.status.${status}`)}
    </span>
  )
}
